export const SET_FILTERS= 'SET_FILTERS'
export const SET_MODELS= 'SET_MODELS'
export const RESET_MODELS= 'RESET_MODELS'
export const SET_SEARCHENDED= 'SET_SEARCHENDED'
export const SHOW_MODEL = 'SHOW_MODEL'
export const HIDE_MODEL = 'HIDE_MODEL'
// export const SAVE_APPLICATION= 'SAVE_APPLICATION'
export const SET_FAVORITES = 'SET_FAVORITES'
export const SET_APPLICATION_FAVORITES = 'SET_APPLICATION_FAVORITES'
export const SET_FAVORITES_IDS = 'SET_FAVORITES_IDS'
export const SET_APPLICATION= 'SET_APPLICATION'
export const SET_HEART= 'SET_HEART'
export const SET_NOOF_HEARTS= 'SET_NOOF_HEARTS'
export const SET_PROPOSAL= 'SET_PROPOSAL'
export const SET_MODE = 'SET_MODE'
export const SET_PROJECT = 'SET_PROJECT'
export const SET_CONFIRM_DELETE_FAVORITE = 'SET_CONFIRM_DELETE_FAVORITE'
export const SHOW_CONFIRM_DELETE_FAVORITE = 'SHOW_CONFIRM_DELETE_FAVORITE'
export const SET_DELETE_FAVORITE_ID = 'SET_DELETE_FAVORITE_ID'
export const FORCE_HIDE_PREVIEW = 'FORCE_HIDE_PREVIEW'
export const FORCE_RELOAD_FAVORITES = 'FORCE_RELOAD_FAVORITES'
export const DELETE_ALL_FAVORITES = 'DELETE_ALL_FAVORITES'
export const SET_APPLICATION_ID = 'SET_APPLICATION_ID'
export const SET_PROPOSAL_ID = 'SET_PROPOSAL_ID'

